import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import type {RootState} from './index';
import {saveToken} from '../request/token';
import {checkToken} from '../API/base';

export interface UserState {
  userInfo: {
    name?: string;
    nickname?: string;
    schoolName?: string;
    mobile?: string;
    status?: number;
    gender?: number;
    grade?: number;
    id?: number;
    studyPhase?: number;
    jwtToken?: string;
    avatar?: string;
    biosignature?: string;
    logon?: boolean;
    // web端权益到期时间
    webExpireTime?: string;
    curriculumSetup: {
      xkwGradeId?: number;
      xkwStageId?: number;
      xkwTerm?: string;
      alertDateOfStageReset?: string; // 提醒修改学段时间
      alertDateOfGradeReset?: string; //提醒修改年级时间
      alertDateOfTermReset?: string; // 提醒修改学期时间
      xkwVersionList?: {
        course_id: number;
        stage_id: number;
        /*学科ID */
        subject_id: number;

        /*教材版本ID */
        version_id: number;
      }[];
    };
    xkwStageId?: number;
    /* */
    xkwGradeId?: number;

    /* */
    xkwSubjectId?: number;

    /* */
    xkwTerm?: string;

    /* */
    xkwCoursesTextbookVersionsList?: {
      /*年级ID */
      grade_id: number;

      /*学科ID */
      subject_id: number;

      /*教材版本ID */
      version_id: number;
    }[];
  };
}

const initialState = {
  userInfo: {},
} as UserState;

// 异步获取用户信息
export const getUserInfo = createAsyncThunk(
  'user/getUserInfo',
  async (): Promise<UserState['userInfo']> => {
    const res = await checkToken();
    return res.data;
  },
);

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    saveUserInfo: (
      state,
      action: PayloadAction<Partial<UserState['userInfo']>>,
    ) => {
      state.userInfo = action.payload;
      if (action.payload.jwtToken) {
        saveToken(action.payload.jwtToken);
      }
    },
  },
  extraReducers: builder => {
    builder.addCase(getUserInfo.fulfilled, (state, action) => {
      state.userInfo = action.payload;
    });
  },
});

export const {saveUserInfo} = userSlice.actions;

export const selectUserInfo = (state: RootState) => state.user.userInfo;

const userReducer = userSlice.reducer;

export default userReducer;
